import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { ChooseResponses } from "@/features/Reports/new/ChooseResponses";
import { ReportTemplateResponsesQuery } from "@/features/Reports/new/graphql";
import { WizardPage } from "@/features/Reports/new/WizardPage";

// Present when the user comes back from the preview step, so their selection is kept.
const searchSchema = z.object({
  responseIds: z.array(z.string()).optional(),
});

export const Route = createFileRoute("/$organizationKey/$dossierId/reports/new/$reportTemplateId/")(
  {
    validateSearch: zodValidator(searchSchema),
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { organizationKey, dossierId, reportTemplateId } = Route.useParams();
  const { responseIds } = Route.useSearch();
  const { data } = useSuspenseQuery(ReportTemplateResponsesQuery, {
    variables: { organizationKey, dossierId, reportTemplateId },
  });
  const { suggestedIds, available } = data.dossier.reportResponseSelection;

  return (
    <WizardPage step="responses">
      <ChooseResponses
        key={reportTemplateId}
        template={data.organization.reportTemplate}
        available={available}
        suggestedIds={suggestedIds}
        initialSelectedIds={responseIds}
      />
    </WizardPage>
  );
}
